import { render, staticRenderFns } from "./JVxeDepartSelectCell.vue?vue&type=template&id=a0823c02&scoped=true"
import script from "./JVxeDepartSelectCell.vue?vue&type=script&lang=js"
export * from "./JVxeDepartSelectCell.vue?vue&type=script&lang=js"
import style0 from "./JVxeDepartSelectCell.vue?vue&type=style&index=0&id=a0823c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0823c02",
  null
  
)

export default component.exports